import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { loadUser, logout, handleMicrosoftRedirect} from '../Components/Auth/authThunks';
import * as authActions from '../Components/Auth/authActions';
import { PageRoutes } from '../Routes/index';
import { initializeMsal } from '../Config/msalConfig';
import { CacheService } from '../Services/CacheService';
import { EmergencyReset } from '../utils/emergencyReset';
import { TokenExpiration } from '../utils/tokenExpiration';
import { PATH } from '../Constants/paths';

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => dispatch(loadUser()),
  logout: () => dispatch(logout()),
  handleMicrosoftRedirect: () => dispatch(handleMicrosoftRedirect()),
  dispatch
});
const connector = connect(mapStateToProps, mapDispatchToProps);
interface Props extends ConnectedProps<typeof connector> {}

const _App = (props: Props) => {
  useEffect(() => {
    const initApp = async () => {
      try {
        TokenExpiration.setLogoutFunction(() => {
          props.logout();
          window.location.href = PATH.LANDING;
        });
        await EmergencyReset.checkAndReset();
        await CacheService.checkAndInvalidateCache();
        await initializeMsal();
        
        await props.handleMicrosoftRedirect();
        
        if (localStorage.user) {
          if (TokenExpiration.isTokenExpired()) {
            console.log('Token expired on app initialization, redirecting to login');
            TokenExpiration.handleTokenExpiration();
            return;
          }
          
          props.loadUser();
        } else {
          props.dispatch(authActions.authInitComplete());
        }
      } catch (error) {
        console.error("Error initializing app:", error);
      }
    };
    
    initApp();
    
    // Log user out from all tabs if they log out in one tab
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'user' && event.newValue === null) {
        props.logout();
        window.location.href = PATH.LANDING;
      }
    };
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      // Clean up token monitoring on app unmount
      TokenExpiration.stopMonitoring();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return <PageRoutes />;
};

export const App = connector(_App);